import React from "react";
import PropTypes from "prop-types";

const MaleGenderIcon = ({ className }) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M6 4.33333C6 5.62113 7.04553 6.66667 8.33333 6.66667C9.62113 6.66667 10.6667 5.62113 10.6667 4.33333C10.6667 3.04553 9.62113 2 8.33333 2C7.04553 2 6 3.04553 6 4.33333V4.33333"
      stroke="currentColor"
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.50195 8.5C11.2914 8.5 13.5 10.6225 13.5 13.1807C13.4998 13.3314 13.3608 13.5 13.1348 13.5H3.87012C3.63744 13.5 3.50017 13.3297 3.5 13.1807C3.5 10.7023 5.57693 8.62911 8.24219 8.50586L8.50195 8.5Z"
      stroke="currentColor"
    />
  </svg>
);

MaleGenderIcon.propTypes = {
  className: PropTypes.string,
};

MaleGenderIcon.defaultProps = {
  className: undefined,
};

export default MaleGenderIcon;
